import styled from 'styled-components';

export const Image = styled.img`
  position: absolute;
  bottom: 50px;
  left: 50px;
  width: 40px;
  height: 40px;
  display: block;
  cursor: pointer;
`;
